import AmountRoom from './AmountRoom.container';

export default AmountRoom;
